export const setVisited = () => {
  localStorage.setItem("visited", "true");
};

export const hasVisited = () => {
  return localStorage.getItem("visited") === "true";
};

export const clearMoleculesCache = () => {
  localStorage.removeItem('molecules');
  localStorage.removeItem('moleculesDate');
  localStorage.removeItem('data-present');
  localStorage.removeItem('approve-stale-state');
  console.log('[Cache] Cache des données vidé :', new Date().toISOString());
};
